<!-- 代理等级变更日志 -->
<template>
    <c-dialog ref="upgradeRecordDialog" :title="title" width="1200" height="800" enable-flex :button="false">
        <c-table ref="upgradeRecordTable" height="770">
            <c-table-column label="调整类型" width="80" name="reward_type">
                <template v-slot="{data}">
                    <span v-if="data.upgrade_type==1">会员注册</span>
                    <span v-if="data.upgrade_type==2">总后台变更</span>
                    <span v-if="data.upgrade_type==3">购买代理升级</span>
                    <span v-if="data.upgrade_type==6">邀请保护期过期</span>
                    <span v-if="data.upgrade_type==9">自动升级</span>
                    <span v-if="data.upgrade_type==11">(审批)自动升级</span>
                </template>
            </c-table-column>
            <c-table-column label="调整前等级" name="pre_level_name" width="90"></c-table-column>
            <c-table-column label="调整后等级" name="upgrade_level_name" width="90"></c-table-column>
            <c-table-column label="调整前分享人" width="160">
                <template v-slot="{data}">
                    <div class="flex-center-cross">
                        <c-image :src="data.pre_share_user_head_photo" preview size="30" style="margin-right: 10px;"> </c-image>
                        <span v-if="data.pre_share_user_nick_name && data.pre_share_user_nick_name!=''">{{data.pre_share_user_nick_name}}</span>
                        <span v-else>--</span>
                        <span v-if="data.pre_share_user_phone">{{data.pre_share_user_phone}}</span>
                    </div>
                </template>
            </c-table-column>
            <c-table-column label="调整后分享人" width="160">
                <template v-slot="{data}">
                    <div class="flex-center-cross">
                        <c-image :src="data.upgrade_share_user_head_photo" preview size="30" style="margin-right: 10px;"> </c-image>
                        <span v-if="data.upgrade_share_user_nick_name && data.upgrade_share_user_nick_name!=''">{{data.upgrade_share_user_nick_name}}</span>
                        <span v-else>--</span>
                        <span v-if="data.upgrade_share_user_phone">{{data.upgrade_share_user_phone}}</span>
                    </div>
                </template>
            </c-table-column>
            <c-table-column label="调整处理人" width="160">
                <template v-slot="{data}">
                    <div class="flex-center-cross" v-if="data.upgrade_type==2 || data.upgrade_type==6 || data.upgrade_type==11">
                        <c-image v-if="data.create_user_head_photo" :src="data.create_user_head_photo" preview size="30" style="margin-right: 10px;"> </c-image>
                        <span v-if="data.create_user_name && data.create_user_name!=''">{{data.create_user_name}}</span>
                        <span v-else>--</span>
                        <span v-if="data.create_user_phone">{{data.create_user_phone}}</span>
                    </div>
                    <div v-else>--</div>
                </template>
            </c-table-column>
            <c-table-column label="调整时间" name="create_date" width="155"></c-table-column>
        </c-table>
    </c-dialog>
</template>

<script>
	export default {
		props: {

        },

        data() {
            return {
                title:'代理调整记录',
                serachParams:{}
            }
        },
		
		methods: {
			open(params) {
                this.serachParams = params||{};
                if (params && params.title){
                    this.title = params.title;
                }
                this.$refs.upgradeRecordDialog.open();
                this.$refs.upgradeRecordTable.load({
                    url: '/member_user/upgrade/record/list',
                    data:this.serachParams
                });
			}
		}
	}
</script>